// extracted by mini-css-extract-plugin
export default {"productGrid":"styles__productGrid__lyEHQ","item":"styles__item__HixEm","info":"styles__info__MslG_","productName":"styles__productName__YtL7q"};